import React, { useRef, useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ReplayIcon from '@mui/icons-material/Replay';
import CircularProgress from '@mui/material/CircularProgress';

interface WhatsNewImageProps {
    height: number;
    width: number;
    src: string;
}

export const WhatsNewVideo: React.FC<WhatsNewImageProps> = ({
    height,
    width,
    src,
}) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [isEnded, setIsEnded] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const handleReplay = () => {
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
            videoRef.current.play();
            setIsEnded(false);
        }
    };

    const handleCanPlay = () => {
        setIsLoading(false);
    };

    return (
        <Box
            sx={{
                width,
                height,
                mb: 2,
                backgroundColor: '#e0e0e0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
            }}
        >
            {isLoading && <CircularProgress sx={{ position: 'absolute' }} />}
            <video
                ref={videoRef}
                width={width}
                height={height}
                src={src}
                autoPlay
                muted
                onCanPlay={handleCanPlay}
                onEnded={() => setIsEnded(true)}
            />
            {isEnded && (
                <IconButton
                    onClick={handleReplay}
                    sx={{
                        position: 'absolute',
                        bottom: 8,
                        right: 8,
                        color: '#ffffff',
                    }}
                    aria-label="replay video"
                >
                    <ReplayIcon />
                </IconButton>
            )}
        </Box>
    );
};
